module.exports = require('./lib/memoize');



//////////////////
// WEBPACK FOOTER
// ./~/memoize-weak/index.js
// module id = 175
// module chunks = 0